export default __webpack_public_path__ + "img/Venta.d43013db.jpg";